import { __awaiter, __rest } from "tslib";
import React from 'react';
import { Avatar as AntAvatar } from 'antd';
import useAsync from 'react-use/lib/useAsync';
import { string, number, oneOfType, func, node } from 'prop-types';
import { makeClassName } from '../../utils';
import 'antd/lib/avatar/style/index.less';
import './Avatar.less';
const sizeToPixelMap = {
    small: 28,
    medium: 36,
    large: 107,
};
const getSizeInPixels = (size) => {
    if (Number.isInteger(size)) {
        return size;
    }
    return sizeToPixelMap[size];
};
const Avatar = (props) => {
    const { src, initials, size, className, getImagePromise, thenParser, onImageLoad } = props, otherProps = __rest(props, ["src", "initials", "size", "className", "getImagePromise", "thenParser", "onImageLoad"]);
    const customClass = makeClassName(className, 'kalAvatar', size);
    const userImage = useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!getImagePromise) {
            return null;
        }
        try {
            const response = yield getImagePromise();
            const data = yield thenParser(response);
            const img = yield onImageLoad(data);
            return img;
        }
        catch (_a) {
            return null;
        }
    }), []);
    return (React.createElement(AntAvatar, Object.assign({ src: userImage.value || src, className: customClass, size: getSizeInPixels(size), alt: 'avatar' }, otherProps), src ? null : initials));
};
Avatar.propTypes = {
    className: string,
    src: string,
    initials: node,
    size: oneOfType([string, number]),
    getImagePromise: func,
    thenParser: func,
    onImageLoad: func,
};
Avatar.defaultProps = {
    className: '',
    src: null,
    initials: null,
    size: 'medium',
    getImagePromise: null,
    thenParser: (r) => r.json(),
    onImageLoad: () => null,
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map